// extracted by mini-css-extract-plugin
module.exports = {"list":"list___3Bsxf","row":"row___O6qb_","text":"text___1gLol","question-link":"question-link___oSsIR","date":"date___2cKXJ","empty":"empty___Fdwpg"};